import React from 'react';
import { LayoutDashboard, Share2, Images, CalendarDays, User, Settings } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import { withNavigation } from './Navigation/NavigationWraper';

const Layout = ({ children }) => {
  const { setIsLoggingOut, setIsCheckingAuth, user } = useAppStore();
  const handleLogout = () => {
    setIsLoggingOut(true);
    setIsCheckingAuth(false);
  };
  const { identity } = user || {};

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
    { name: 'Social Accounts', href: '/socials', icon: Share2 },
    { name: 'Content Gallery', href: '/gallery', icon: Images },
    { name: 'Calendar', href: '/schedule', icon: CalendarDays },
    { name: 'Profile', href: '/profile', icon: User },
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  return (
    <NavigationWrapper
      navigation={navigation}
      identity={identity}
      onLogout={handleLogout}
      logoSrc='/logo/Logo.png'
    >
      {children}
    </NavigationWrapper>
  );
};

const NavigationWrapper = withNavigation(({ children }) => <>{children}</>);

export default Layout;
